import { render, staticRenderFns } from "./list-summary.vue?vue&type=template&id=52d4ad5b"
import script from "./list-summary.vue?vue&type=script&lang=ts"
export * from "./list-summary.vue?vue&type=script&lang=ts"
import style0 from "./list-summary.vue?vue&type=style&index=0&id=52d4ad5b&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52d4ad5b')) {
      api.createRecord('52d4ad5b', component.options)
    } else {
      api.reload('52d4ad5b', component.options)
    }
    module.hot.accept("./list-summary.vue?vue&type=template&id=52d4ad5b", function () {
      api.rerender('52d4ad5b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/cart/list-summary.vue"
export default component.exports